import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const AboutSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=800&q=80"
                alt="Students in classroom"
                className="w-full h-[400px] object-cover"
              />
            </div>
            {/* Floating Badge */}
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, type: "spring" }}
              className="absolute -bottom-6 -right-6 bg-secondary text-white p-6 rounded-2xl shadow-lg"
            >
              <div className="text-4xl font-bold">19+</div>
              <div className="text-sm">Years of Excellence</div>
            </motion.div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-secondary font-medium text-sm uppercase tracking-wider">
              About Our School
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4">
              Building Future Leaders Since 2005
            </h2>
            <div className="section-divider mb-6"></div>

            <p className="text-gray-600 mb-6 leading-relaxed">
              ID4U School is a premier educational institution committed to providing 
              comprehensive education that nurtures the intellectual, physical, emotional, 
              and social development of every student. Our mission is to inspire a lifelong 
              love of learning and prepare students to become responsible global citizens.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              With state-of-the-art facilities, a dedicated team of educators, and a 
              curriculum that blends academic rigor with creative exploration, we create 
              an environment where students can discover their potential and achieve excellence.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-slate-50 p-4 rounded-xl">
                <div className="text-2xl font-bold text-primary">2500+</div>
                <div className="text-sm text-gray-600">Happy Students</div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl">
                <div className="text-2xl font-bold text-primary">120+</div>
                <div className="text-sm text-gray-600">Expert Teachers</div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl">
                <div className="text-2xl font-bold text-primary">98%</div>
                <div className="text-sm text-gray-600">Pass Rate</div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl">
                <div className="text-2xl font-bold text-primary">50+</div>
                <div className="text-sm text-gray-600">Awards Won</div>
              </div>
            </div>

            <Link to="/about">
              <Button className="bg-primary hover:bg-primary/90 rounded-full px-6">
                Learn More About Us
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
